import apiBase from "./apiBase";

class AppSettingsApi {
  static get() {
    return apiBase.create().get('/app/settings');
  }

}

export default AppSettingsApi;
